<section id="secao-quero-incubar">
  <div class="container">
    <div class="row r-icon">
      <div class="col-md-4 c-icon">
        <span class="material-icons icon ml-5"> tips_and_updates </span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-4 c-botao">
        <div class=" r-titulo">
          <h1 class="titulo">Programa de incubação de empresas Educere</h1>
        </div>
        <div routerLink="/incubar-empresa" class="row r-botao">
          <button type="button" class="btn botao">Quero Incubar!</button>
        </div>
      </div>
    </div>
  </div>
</section>
